import ParsedDayScheduleCalendar from '@/components/Common/ParsedDayScheduleCalendar';
import WorkHoursOperationForm from '@/components/Projects/Common/WorkHoursOperationForm';

// @vue/component
export default {
  name: 'ProjectMainData',

  components: {
    ParsedDayScheduleCalendar,
    WorkHoursOperationForm,
  },

  props: {
    projectUuid: {
      type: String,
      default: () => ({}),
    },
  },

  data() {
    return {
      isWorkHoursModalVisible: false,
    };
  },

  computed: {
    projectDetails() {
      return this.$store.getters['client/project/details'];
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/getProjectDetails',
      ]);
    },
  },

  async created() {
    await this.getProjectDetails();
  },

  methods: {
    async getProjectDetails() {
      await this.$store.dispatch('client/project/getProjectDetails', this.projectUuid);
    },
  },
};
